<template>
  <div>
    <div class="list-box" v-for="(item,index) in list" :key="index">
      <div class="head-box">
        <span class="left" v-if="awardSetType !== 'encourage'">{{awardName}}({{index + 1}})</span>
        <span class="left" v-else></span>
        <div class="right">
          <span class="del" @click="del(index)">删除</span>
          <span class="edit" v-if="awardSetType === 'random' || !isEdit" @click="edit(index)">编辑</span>
        </div>
      </div>
      <template v-if="awardSetType === 'global' || awardSetType === 'office'">
        <div class="row">
          <span class="row-key">名次</span>
          <span class="row-value">{{item.rankingStart}}名 至 {{item.rankingEnd}}名</span>
        </div>
      </template>
      <template v-if="awardSetType === 'ladder' || awardSetType=== 'random'">
        <div class="row">
          <span class="row-key">所需数钱次数</span>
          <span class="row-value">{{item.countTime}}</span>
        </div>
      </template>
      <div class="row">
        <span class="row-key">奖品类型</span>
        <span class="row-value">{{item.prizeType | prizeType}}</span>
      </div>
      <template v-if="item.prizeType === 'award'">
        <div class="row">
          <span class="row-key">奖品名称</span>
          <span class="row-value">{{item.prizeName}}</span>
        </div>
        <div class="row" v-if="awardSetType !== 'encourage'">
          <span class="row-key">奖品总份数</span>
          <span class="row-value">{{item.prizeCount}}份</span>
        </div>
      </template>
      <template v-if="item.prizeType === 'coupon'">
        <div class="row">
          <span class="row-key">优惠券名称</span>
          <span class="row-value">{{item.prizeName}}</span>
        </div>
        <div class="row"  v-if="awardSetType !== 'encourage'">
          <span class="row-key">优惠券总份数</span>
          <span class="row-value">{{item.prizeCount}}份</span>
        </div>
        <div class="row">
          <span class="row-key">优惠券内容</span>
          <span class="row-value width">{{item.couponContent}}</span>
        </div>
        <div class="row">
          <span class="row-key">
            优惠券有效期
            <van-icon class="icon" name="question" @click="toast"/>
          </span>
          <span class="row-value">{{item.couponIndate}}天</span>
        </div>
      </template>
      <template v-if="awardSetType=== 'random'">
        <div class="row">
          <span class="row-key">中奖概率</span>
          <span class="row-value">{{item.probability}} %</span>
        </div>
      </template>
      <div class="row" v-if="item.prizeType === 'award' && item.prizeImg">
        <span class="row-key">奖品图片</span>
        <img class="img-box" :src="item.prizeImg"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    awardSetType: {
      type: String,
      default: ""
    },
    list: {
      type: Array,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {                 
    }
  },
  computed: {
    awardName() {
      let map = {
        global: '全国奖励',
        office: '办事处奖励',
        ladder: '阶梯奖励', 
        random: '随机奖励',
        encourage: '鼓励奖励',
      }
      return map[this.awardSetType]
    }
  },
  methods: {
    del(index) {
      this.$emit('del',index,this.awardSetType)
    },
    edit(index) {
      this.$emit('edit',index,this.awardSetType)
    },
    toast() {
      this.$toast({
        message: "优惠券的使用时效，从领取当日计算",
        duration: 3000
      });
    }
  },
  filters: {
    prizeType(value) {
      return value === 'award' ? '奖品' : '优惠券(线下)'
    }
  }
}
</script>

<style lang="stylus" scoped>
  .list-box {
    margin: 16px;
    box-sizing: border-box;
    border-bottom: 1px solid #ebedf0;
    .head-box {
      display: flex;
      justify-content: space-between;
      .right {
        .edit {
          color: #ff6b31;
          margin-left: 4px;
        }
      }
    }
    .row {
      display: flex;
      justify-content: space-between;
      padding: 10px 0;
      .row-value {
        color: #000;
      }
      .icon {
        margin-left:4px;
      }
      .img-box {
        width: 80px;
        height: 80px;
        background: #ccc;
      }
      .width {
        width: 220px;
      }
    }
  }
  
  
</style>